import React from 'react';
import { useNotification } from '../providers/NotificationProvider';
import { Snackbar } from 'components/ui/Feedback';

const NotificationMessage = (): JSX.Element => {
    const { message, clearMessage, messageType } = useNotification();

    return (
        <Snackbar
            open={!!message}
            message={message ?? ''}
            type={messageType || 'info'}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            onClose={clearMessage}
            onUndo={undefined}
        />
    );
};

export default NotificationMessage;
